import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/by-slug/{slug}']['GET'];

type Input = {
  slug: string;
};

type Output = ThisApi['response'];

const getDynamicPdfTemplatesBySlug = async ({ slug }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates/by-slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates by slug:', error);
    throw error;
  }
};

export default getDynamicPdfTemplatesBySlug;
